export const eventBus = document;
export let initialData = {};